import React from 'react';
import PropTypes from 'prop-types';

const DeletePath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M14.266 2a1 1 0 0 0-.993.89L13.15 4H4.5a.5.5 0 0 0-.5.5V6h24V4.5a.5.5 0 0 0-.5-.5h-8.707l-.122-1.11a1 1 0 0 0-.994-.89h-3.411zM6 7l1.827 19.19A2.002 2.002 0 0 0 9.818 28h12.364a2 2 0 0 0 1.99-1.81L26 7H6z"
    />
  );
};

DeletePath.propTypes = {
  fill: PropTypes.string,
};

export default DeletePath;



// WEBPACK FOOTER //
// ./src/icon/svgs/interaction/delete.jsx